import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react'
import { FormContext } from '../../FormContext';
import { getDateDepend, getMinMaxDate } from '../../utils/utilFunctions';
import InputAddRemove from './InputAddRemove';
import { isFieldSigned,determineIsDisabled  } from './utils.js';
import './Input.css';
const Input = ({ field_multiple_primary, field_multiple_id, field_multiple, field_autocomplete, field_type, field_disabled_approver, field_column, field_id, field_label, field_placeholder, field_disabled, field_mandatory, field_value = "", field_date_depend, field_number_max, field_number_min, field_multiple_type }) => {
  const { handleChangeInput, handleAddField, formElements, handleRemoveLastField, formStatus, formPageType, formApprovalIndex, formUserLock, formMultipleType, formChatPerson, formOfficers } = useContext(FormContext);
  const [minDate, setMinDate] = useState(null)
  const [maxDate, setMaxDate] = useState(null)


  if (field_autocomplete == 'User') {
    console.log('user', field_value)
    console.log('user2', field_value === "")
    console.log('formApprovalIndex', formApprovalIndex)
    console.log('field_id', field_id)
    console.log('compare', parseInt(field_id.slice(-1)) < formApprovalIndex)
  }

  useEffect(() => {

    if (typeof field_date_depend !== 'undefined') {
      const date_depend_arr = field_date_depend.split("/");
      try {
        const date_depend = getDateDepend(formElements, date_depend_arr[0])
        const minmax_date = getMinMaxDate(date_depend, date_depend_arr[1], date_depend_arr[2], date_depend_arr[3])
        setMinDate(minmax_date.min_date)
        setMaxDate(moment(minmax_date.max_date).format("YYYY-MM-DD"))

      } catch (error) {
      }

    }
  }, [formElements, field_date_depend])


 
  let isSigned = isFieldSigned(field_id, formMultipleType, formChatPerson, formOfficers, field_multiple_type);


  const handleAutoComplete = (event, field_autocomplete) => {
    console.log('using handleAutoComplete')
    if (field_autocomplete) {
      if (field_autocomplete === "User") {
        console.log('handleAutoComplete', event, event.target.value, field_id)
        if (event.target.value.length >2) {
          window[`autocomplete${field_autocomplete}`](event.target.value, field_id);
        }
      }
    }

  };


  const hideTimePicker = (event, field_id, field_type) => {

    //console.log('on blur~~~~~',field_id)
    if (field_type == 'date' || field_type == 'time') {
      window['hideTimePicker'](field_id);
    }
    handleChangeInput(field_id, event);

  }
  const handleFocus = (field_id, event, field_type) => {
    switch (field_type) {
      case 'date':
        window['triggerDatePicker'](field_id, minDate, maxDate);
        handleChangeInput(field_id, event);
        break;
      case 'time':
        window['triggerTimePicker'](field_id);
        handleChangeInput(field_id, event);
        break;


      default:
        handleChangeInput(field_id, event);
        break;
    }
    // if (field_type==='date') {
    //   window['triggerDatePicker'](field_id)
    //   handleChangeInput(field_id, event)
    // }else{
    //   handleChangeInput(field_id, event)

    // }
  }

  const validateMinMax = (value) => {
    if ((field_number_min || field_number_max) && value != "") {
      return (value > field_number_max) ? field_number_max : (value < field_number_min) ? field_number_min : value
    } else {
      return value
    }
  }

  if (field_multiple_type === 'mapprover_officer') {
    console.log('isDisabled field_id', field_id)
    console.log('isDisabled Condition 1:', formUserLock && formPageType === 'user');
    console.log('isDisabled Condition 2:', formPageType === 'user');
    console.log('isDisabled Sub-Condition 1:', field_multiple_id === "mapprover");
    console.log('isDisabled Sub-Condition 2:', field_id.startsWith('user_approver_') || field_id.startsWith('user_action_'));
    console.log('isDisabled Sub-Condition 3:', parseInt(field_id.slice(-1)) < formApprovalIndex);
    console.log('isDisabled Condition 3:', field_disabled_approver === '1' || field_disabled);
    console.log('isDisabled Condition 4:', isSigned);
    console.log('isDisabled Condition 5:', formStatus === 'Submitted' && (field_multiple_id === 'mapprover' || field_id.startsWith('user_approver_')));
  }

 


const isDisabled = determineIsDisabled(
  formUserLock,
  formPageType,
  field_multiple_id,
  isSigned,
  field_id,
  formApprovalIndex,
  field_disabled_approver,
  field_disabled,
  formStatus
);

// const isDisabled = false
  return (
    <div className={`form-group ${field_column ? field_column : 'col-sm-6'}`}>
      <label>{field_label} <font color="red">{field_mandatory === 'yes' ? '*' : ''}</font></label>
      {/* <p>field_multiple_type {String(field_multiple_type)}</p>
      <p>formMultipleType {String(formMultipleType)}</p> */}


      <input type={field_type === 'number' ? 'number' : 'text'}
        placeholder={field_placeholder ? field_placeholder : ' '}
        value={validateMinMax(field_value)}

        disabled={isDisabled}

        // disabled={field_disabled_approver == "1" || field_disabled || isSigned ||(formStatus=== 'Submitted' && (field_multiple_id==='mapprover'|| field_id.startsWith("user_approver_")))}
        onChange={event => handleChangeInput(field_id, event)}
        onFocus={event => handleFocus(field_id, event, field_type)}
        onKeyUp={(event) => handleAutoComplete(event, field_autocomplete)}
        min={field_number_min}
        max={field_number_max}
        className="form-control form-input force-info" id={field_id} autoComplete="off" data-target-input="nearest" data-target={`#${field_id}`} data-toggle={field_type == 'time' && "datetimepicker"} onBlur={(event) => hideTimePicker(event, field_id, field_type)} />



      {/* <input type="text" className="form-control form-input force-info" id={field_id} onkeyup="if( (!$(this).val().match(/^[A-Za-z]+$/) && $(this).val().length>=5) || ($(this).val().match(/^[A-Za-z]+$/) && $(this).val().length>=2)) autocompleteUser($(this).val(), this);" placeholder="Enter email" autoComplete="off" /> */}

      {/* {(formPageType === 'user'&&field_multiple_id === "mapprover" && field_multiple_primary == "yes"?true :field_multiple_primary == "yes" && formStatus!== 'Submitted')&&<div className='mt-3 text-right'>
        <u className="text-success mr-3" onClick={() => handleAddField(field_id)}>Add </u>
        <u className="text-danger" onClick={() => handleRemoveLastField(field_id)}>Remove </u>
      </div>} */}

      {!formUserLock && <InputAddRemove field_id={field_id} field_multiple_id={field_multiple_id} field_multiple_type={field_multiple_type} />}
    </div>

  )
}

export default Input
